import { View } from 'native-base';
import { ScrollView } from 'react-native';

import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';

import { AddMoreButtonsSection } from './add-more-buttons-section';
import { DeliveryFeesSection } from './delivery-fees-section';
import { DonationsSection } from './donations-section';
import { FoodwareSection } from './foodware-section';
import { UpsellSection } from './upsell-section';
import { YourCartSection } from './your-cart-section';

export const CartContent = () => {
  const enableFoodwareItems = useFlag(LaunchDarklyFlag.ENABLE_FOODWARE_ITEMS);
  const isDonationsEnabled = useFlag(LaunchDarklyFlag.ENABLE_FOUNDATION_DONATIONS);

  return (
    <ScrollView>
      <View style={{ gap: 16 }}>
        <YourCartSection />
        <AddMoreButtonsSection />
        <UpsellSection />
        {enableFoodwareItems && <FoodwareSection />}
        {isDonationsEnabled && <DonationsSection />}
        <DeliveryFeesSection />
      </View>
    </ScrollView>
  );
};
